import React, {useImperativeHandle, forwardRef,
  useRef,
  useEffect,
  useState,
} from "react";
import { Modal } from "bootstrap";
import uuid from "react-uuid";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";
import TapSelect from "../../../components/ui/TapSelect";
import Loader from "../../../components/ui/Loader/Loader";
import TapHelper from "../../../services/TapHelper";
import { HRM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import { toast } from "react-toastify";
import HttpAPICall from "../../../services/HttpAPICall";

const AttendenceEditDeleteModal = forwardRef(({ isReadOnly, afterSucess }, ref) => {
    
    const access_token          =   useSelector((state) => state.auth.access_token);
    const modalId               =   uuid();
    const formId                =   uuid();
    const modalElem             =   useRef(null);
    const modal                 =   useRef(null);
    const date                  =   new Date();

    
    let initFormData            =   {
      loading                       :   false,
      submitting                    :   false,
      transaction_date              :   date,
      checkIn_hour                  :   "",
      checkIn_minutes               :   "",
      checkIn_note                  :   "",

      checkOut_hour                 :   "",
      checkOut_minutes              :   "",
      checkOut_note                 :   "",
      employeeName                  :   "",
      action                        :   "checkin"
    };

    
    const [formData, setFormData]               =   useState({ ...initFormData });
    const [attendence, setAttendence]           =   useState(null);
    const [isCheckIn, setIsCheckIn]             =   useState(false);
    const [isCheckOut, setIsCheckOut]           =   useState(false);
    const [isEdit, setIsEdit]                   =   useState(false);
    
    const hourOptions   =   TapHelper.range(0, 23).map((v) => ({
      label: v,
      value: v,
    }));
    const minuteOptions =   TapHelper.range(0, 59).map((v) => ({
      label: v,
      value: v,
    }));

    useEffect(() => {
        modalElem.current = document.getElementById(modalId);
        modal.current = new Modal(modalElem.current, {
          keyboard: false,
          backdrop: false,
        });
        return () => {
          if (modal.current) {
            modal.current.dispose();
          }
        };
    }, []);

    useImperativeHandle(ref, () => ({
      initModalHandler: (attendance, employeeName, isEdit) => {
        formDataInit(attendance, employeeName);
        modalOpen();
        setAttendence(attendance);
        setIsEdit(isEdit);
      },
    }));

    const modalOpen = () => {
      if (modal.current) {
        modal.current.show();
      }
    };

    const modalClose = () => {
      if (modal.current) {
        modal.current.hide();
      }
      setIsCheckIn(false);
      setIsCheckOut(false);
      setAttendence(null);
      setFormData({ ...initFormData });
    };

    const formDataInit = (attendance, employeeName) => {
        const checkInMinutes                  =   attendance.check_in_minutes || "00:00";
        const [checkInHour, checkInMinute]    =   checkInMinutes.split(":");
        const checkOutMinutes                 =   attendance.check_out_minutes || "00:00";
        const [checkOutHour, checkOutMinute]  =   checkOutMinutes.split(":");

        setFormData((pd) => ({
            ...pd,
            loading             :   false,
            transaction_date    :   attendance.date
            ? new Date(attendance.date)
            : date,
            checkIn_hour        :   parseInt(checkInHour, 10),
            checkIn_minutes     :   parseInt(checkInMinute, 10),
            checkIn_note        :   attendance.checkin_note || "",
            
            checkOut_hour       :   parseInt(checkOutHour, 10),
            checkOut_minutes    :   parseInt(checkOutMinute, 10),
            checkOut_note       :   attendance.checkout_note || "",
            employeeName,
        }));
    };
    const handleDeleteAttendance = (event) => {
        event.preventDefault();
        const attendence_id = attendence.id;
        const params = {action : formData.action};
        HttpAPICall.withAthorization("DELETE", `${HRM_API_BASE_URL_2}/daily_attendance/delete_attendance/${attendence_id}`, access_token, params, {},(res) => { 
            toast.success(res.data.msg, {position: toast.POSITION.TOP_RIGHT});
            if (afterSucess) {
                afterSucess()
            }}
        ).catch((error) => {
            toast.error(error.message, {position: toast.POSITION.TOP_RIGHT})
        })
        modalClose();
    };

    const handleEditAttendence = (event) => {
        event.preventDefault();
        let data                =   {
          action                    :   formData.action,
          attendance_id             :   attendence.id,
          transaction_date          :   formData.transaction_date.toISOString().split("T")[0],
          checkIn_hour              :   formData.checkIn_hour,
          checkIn_minutes           :   formData.checkIn_minutes,
          checkIn_note              :   formData.checkIn_note
        };

        if(formData.action === 'checkout') {
            data                =   {
                ...data, 
                checkOut_hour       :   formData.checkOut_hour,
                checkOut_minutes    :   formData.checkOut_minutes,
                checkOut_note       :   formData.checkOut_note,
            }
        }

        HttpAPICall.withAthorization( "PUT", `${HRM_API_BASE_URL_2}/daily_attendance/edit_attendance`, access_token,{}, data, (res) => {
            toast.success(res.data.msg, {position: toast.POSITION.TOP_RIGHT});
            if (afterSucess) {
              afterSucess();
            }
          }
        ).catch((error) => {
          toast.error("Error updating attendance record: " + error.message, {
            position: toast.POSITION.TOP_RIGHT,
          })
        })
        modalClose();
    }

    const handleCheckInBox          =   ()  => {
        if(isEdit) {
            setIsCheckIn(!isCheckIn);
        }else {
            const newCheckInState = !isCheckIn;
            setIsCheckIn(newCheckInState);
            if (newCheckInState && attendence.check_out_minutes ) {
              setIsCheckOut(true);
            }
        }
    }

    const handleCheckOutBox         =   ()  =>  {
        if (!isCheckIn || isEdit) {
            setIsCheckOut((prev) => !prev);
        }
        setFormData(pre => ({...pre, action : "checkout"}));
    }

    return (
      <div className="modal fade" id={modalId} tabIndex="-1" ref={modalElem}>
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {isEdit ? "Edit Attendance" : "Delete Attendance"}
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" disabled={formData.submitting || formData.loading}></button>
            </div>
            <div className="modal-body">
              {formData.loading ? (
                <Loader />
              ) : (
                <form id={formId + "Form"}>
                  <div className="row align-items-center mb-3">
                    <div className="col-sm-3">
                      <label className="form-label">Employee</label>
                    </div>
                    <div className="col-sm-9">
                      {formData.employeeName}
                    </div>
                  </div>
                  {/* Check-In Section */}

                  <div className="d-flex align-items-center">
                    <input
                        type="checkbox"
                        checked={isCheckIn}
                        onChange={handleCheckInBox}
                    />
                    <span className="ms-2">{isEdit ? "Edit Check-In" : "Delete Check-In"}</span>
                  </div>
                  <br />

                  <div className="row align-items-center mb-3">
                    <div className="col-sm-3">
                      <label className="form-label require">Check-In</label>
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Date</label>
                      <DatePicker
                        selected={formData.transaction_date}
                        onChange={(d) => {
                          if (!isReadOnly) {
                            setFormData((pd) => ({
                              ...pd,
                              transaction_date: d,
                            }));
                          }
                        }}
                        dateFormat="dd-MMM-yyyy"
                        className="form-control form-control-sm"
                        showMonthDropdown
                        showYearDropdown
                        autoComplete="off"
                        scrollMonthYearDropdown
                        required={true}
                        maxDate={new Date()}
                        disabled={true}
                        placeholderText="Please Enter Date"
                      />
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Hour</label>
                      <TapSelect
                        required
                        options={hourOptions}
                        value={hourOptions.find(
                          (o) => o.value === formData.checkIn_hour
                        )}
                        changeEvent={(o) => {
                          if (!isReadOnly ) {
                            setFormData((d) => ({
                              ...d,
                              checkIn_hour: o ? o.value : null,
                            }));
                          } else {
                            setFormData((d) => ({
                              ...d,
                              checkIn_hour: o ? o.value : null,
                            }));
                          }
                        }}
                        placeholder="Select Hours"
                        isDisabled={isEdit ? !isCheckIn : isReadOnly}
                      />
                    </div>
                    <div className="col-sm-3">
                      <label className="form-label">Minutes</label>
                      <TapSelect
                        required
                        options={minuteOptions}
                        value={minuteOptions.find(
                          (o) => o.value === formData.checkIn_minutes
                        )}
                        changeEvent={(o) => {
                          if (!isReadOnly) {
                            setFormData((d) => ({
                              ...d,
                              checkIn_minutes: o ? o.value : null,
                            }));
                          } else {
                            setFormData((d) => ({
                              ...d,
                              checkIn_minutes: o ? o.value : null,
                            }));
                          }
                        }}
                        placeholder="Select Minutes"
                        isDisabled={isEdit ? !isCheckIn : isReadOnly}
                      />
                    </div>
                  </div>

                  <div className="row align-items-center my-3">
                    <div className="col-sm-3">
                      <label className="form-label ">Check-in-Note</label>
                    </div>
                    <div className="col-sm-9">
                      <textarea
                        name="note"
                        value={formData.checkIn_note}
                        onChange={(e) => {
                          if (!isReadOnly) {
                            setFormData((d) => ({
                              ...d,
                              checkIn_note: e.target.value,
                            }));
                          } else {
                            setFormData((d) => ({
                              ...d,
                              checkIn_note: e.target.value,
                            }));
                          }
                        }}
                        className="form-control"
                        style={{ height: "80px" }}
                        disabled={isEdit ? !isCheckIn : isReadOnly}
                      />
                    </div>
                  </div>

                 
                  {/* Check-Out Section */}
                    {
                      attendence?.check_out_minutes ? 
                        <>
                          <div className="d-flex align-items-center">
                            <input
                              type="checkbox"
                              checked={isCheckOut}
                              onChange={handleCheckOutBox}
                              disabled={!attendence?.check_out_minutes && !isEdit}
                            />
                            <span className="ms-2">{isEdit ? "Edit Check-Out" : "Delete Check-Out"}</span>
                          </div>
                          <div className="row align-items-center mb-3">
                            <div className="col-sm-3">
                              <label className="form-label require">Check-Out</label>
                            </div>
                            <div className="col-sm-3">
                              <label className="form-label">Date</label>
                              <DatePicker
                                selected={formData.transaction_date}
                                onChange={(d) => {
                                  if (!isReadOnly) {
                                    setFormData((pd) => ({
                                      ...pd,
                                      transaction_date: d,
                                    }));
                                  }
                                }}
                                dateFormat="dd-MMM-yyyy"
                                className="form-control form-control-sm"
                                showMonthDropdown
                                showYearDropdown
                                autoComplete="off"
                                scrollMonthYearDropdown
                                required={true}
                                maxDate={new Date()}
                                disabled={true}
                                placeholderText={`Please Enter Date `}
                              />
                            </div>
                            <div className="col-sm-3">
                              <label className="form-label">Hour</label>
                              <TapSelect
                                required
                                options={hourOptions}
                                value={hourOptions.find(
                                  (o) => o.value === formData.checkOut_hour
                                )}
                                changeEvent={(o) => {
                                  if (!isReadOnly) {
                                    setFormData((d) => ({
                                      ...d,
                                      checkOut_hour: o ? o.value : null,
                                    }));
                                  } else {
                                    setFormData((d) => ({
                                      ...d,
                                      checkOut_hour: o ? o.value : null,
                                    }));
                                  }
                                }}
                                placeholder="Select Hours"
                                isDisabled={isEdit ? !isCheckOut : isReadOnly}
                              />
                            </div>
                            <div className="col-sm-3">
                              <label className="form-label">Minutes</label>
                              <TapSelect
                                required
                                options={minuteOptions}
                                value={minuteOptions.find(
                                  (o) => o.value === formData.checkOut_minutes
                                )}
                                changeEvent={(o) => {
                                  if (!isReadOnly) {
                                    setFormData((d) => ({
                                      ...d,
                                      checkOut_minutes: o ? o.value : null,
                                    }));
                                  } else {
                                    setFormData((d) => ({
                                      ...d,
                                      checkOut_minutes: o ? o.value : null,
                                    }));
                                  }
                                }}
                                placeholder="Select Minutes"
                                isDisabled={isEdit ? !isCheckOut : isReadOnly}
                              />
                            </div>
                          </div>
                          <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                              <label className="form-label ">Check-out-Note</label>
                            </div>
                            <div className="col-sm-9">
                              <textarea
                                name="note"
                                value={formData.checkOut_note}
                                onChange={(e) => {
                                  if (!isReadOnly) {
                                    setFormData((d) => ({
                                      ...d,
                                      checkOut_note: e.target.value,
                                    }));
                                  } else {
                                    setFormData((d) => ({
                                      ...d,
                                      checkOut_note: e.target.value,
                                    }));
                                  }
                                }}
                                className="form-control"
                                style={{ height: "80px" }}
                                disabled={isEdit ? !isCheckOut : isReadOnly}
                              />
                            </div>
                          </div>
                        </>
                        :
                        ""}
                </form>
              )}
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={modalClose}>
                Close
                </button>
                {
                isEdit 
                ? 
                    <button type="button" form={formId + "Form"} onClick={handleEditAttendence} className="btn btn-primary" disabled={!isCheckIn && !isCheckOut}>Save Changes</button>
                : 
                    <button type="button" form={formId + "Form"} onClick={handleDeleteAttendance} className="btn btn-danger">Delete</button>
                }
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default AttendenceEditDeleteModal;
